import * as React from 'react';
import style from '../../../LibraryView.scss';
import OperationDetails from '../../../../TypeDetails/OperationDetails';
import { sectionPrefix } from '../../../../NavigationMenu/utils';
import { HashPrefixProvider } from '../../../../HashPrefixProvider';
import { IntersectionSubscriber } from '../../../../SectionIntersectionDetection/IntersectionSubscriber/index';
import { CodeExamples } from '../../../../CodeExamples';

export const Operation = ({ node, operation, prefix }) => {
  const hashPrefix = sectionPrefix(prefix, operation.urlFormat);
  const JSLayoutType = node?.data?.layoutType === 'JS';
  return (
    <section className={style.sectionWrapper}>
      <IntersectionSubscriber
        className={style.intersectionSubscriber}
        tagName="div"
        id={hashPrefix}
      />
      <HashPrefixProvider hashPrefix={hashPrefix}>
        <OperationDetails
          id={hashPrefix}
          node={node}
          key={`__typeDetails_${operation.name}`}
          operation={operation}
          prefix={prefix}
        />
        <CodeExamples
          data={operation}
          prefix={prefix}
          JSLayoutType={JSLayoutType}
        />
      </HashPrefixProvider>
    </section>
  );
};
